let QuestionsConfiguration = [];

//--------------GENERALS
QuestionsConfiguration["name"] = { 
    field: "name",
    text: "Nombre completo",
    note: "",
    options: [],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "Nombre y apellidos",
    rules: ["not-null"],
    type: "OpenQuestion",
    value: "",
    otherValue:"",
    isError:false,
    errors:[]
};

QuestionsConfiguration["birthday"] = { 
    field: "birthday",
    text: "Fecha de nacimiento",
    note: "",
    options: [],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "DateQuestion",
    value: "",
    otherValue:"",
    isError:false,
    errors:[]
};

QuestionsConfiguration["email"] = { 
    field: "email",
    text: "Correo electrónico",
    note: "",
    options: [],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "EmailQuestion",
    value: "",
    otherValue:"",
    isError:false,
    errors:[]
};

QuestionsConfiguration["phone"] = { 
    field: "phone",
    text: "Número de celular",
    note: "",
    options: [],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "PhoneQuestion",
    value: "",
    otherValue:"",
    isError:false,
    errors:[]
};

//---------------GENERALS

//---------------HISTORIAL
QuestionsConfiguration["attendanceReason"] = { 
    field: "attendanceReason",
    text: "1. Motivo de consulta",
    note: "",
    options: [
        {text: "Seleccionar el motivo que más se ajuste", value: ""},
        {text: "Mordida", value: "bite"},
        {text: "Alineación", value: "alignment"},
        {text: "Separación", value: "separation"},
        {text: "Estetica", value: "esthetic"},
        {text: "General", value: "general"},
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[]
};

QuestionsConfiguration["regularMedicine"] = { 
    field: "regularMedicine",
    text: "2. ¿Toma algún medicamento con regularidad?",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
    otherText:"Especificar"
};

QuestionsConfiguration["systematicPathology"] = { 
    field: "systematicPathology",
    text: "3. ¿Tiene alguna patología sistematica?",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
    otherText:"Especificar"
};

QuestionsConfiguration["hasOrthodontics"] = { 
    field: "hasOrthodontics",
    text: "4. ¿Tuvo ortodoncia? ",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
    otherText:"¿Cuando? y  ¿Por cuanto tiempo?"
};

QuestionsConfiguration["isInTreatment"] = { 
    field: "isInTreatment",
    text: "5. ¿Se encuentra actualmente en tratamiento odontologico? ",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
    otherText:"Especificar"
};

QuestionsConfiguration["hasTeethSore"] = { 
    field: "hasTeethSore",
    text: "6. ¿Siente molestia en los dientes y/o encias?",
    note: "",
    options: [
        {text: "Selecciona una opción", value: ""},
        {text: "No tiene molestias", value: "No tiene molestias"},
        {text: "Sangrado", value: "Sangrado"},
        {text: "Dolor", value: "Dolor"},
        {text: "Dificultad para abrir la boca", value: "dificultad para abrir la boca"},
        {text: "Dolor al masticar", value: "Dolor al masticar"},
        {text: "Ruido en la mandibula", value: "Ruido en la mandibula"},
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
    otherText:"Especificar"
};

QuestionsConfiguration["hasBridges"] = { 
    field: "hasBridges",
    text: "7. ¿Tiene puentes o implantes dentales? ",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
    otherText:"¿En que diente?"
};

//---------------HISTORIAL

//---------------RECOGER

QuestionsConfiguration["pickUpPlace"] = { 
    field: "pickUpPlace",
    text: "Dirección para recoger",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
};

QuestionsConfiguration["receptionDate"] = { 
    field: "receptionDate",
    text: "Fecha",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
};

QuestionsConfiguration["receptionTime"] = { 
    field: "receptionTime",
    text: "Horario:",
    note: "",
    options: [
    ],
    predefinedValue: "",
    predefinedOtherValue:"",
    placeHolder: "",
    rules: ["not-null"],
    type: "Select",
    value: "",
    otherValue:"",
    isError:false,
    errors:[],
};



export const GetQuestionsConfiguration = () => QuestionsConfiguration;


// WEBPACK FOOTER //
// ./src/views/Forms/Patient/Configuration/QuestionConfiguration.js